import "core-js/modules/es6.array.map";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.for-each";

/** @jsx jsx */
import { jsx, css } from '@emotion/core';
import { SERIF, OPTIMISTIC_BLUE_DARK, DEFAULT_TEXT, GRAY_000, MEDIA_SMALL_MAX } from '../utilities/constants';
export var ToolTip = function ToolTip(data) {
  var icon = data.icon,
      msg = data.msg;
  var $wrapper = css("\n    position: relative;\n    display: inline-block;\n    margin-left: 0.25em;\n    padding: 5px 0 0 0;\n\n    .wrapper {\n      display: flex;\n      align-items: center;\n    }\n    \n    .icon {\n      background:".concat(OPTIMISTIC_BLUE_DARK, ";\n      line-height: normal;\n      color: white;\n      font-size: 0.5rem;\n      text-align: center;\n      width: 10px;\n      height: 10px;\n      border-radius: 50%;\n\n      &::before {\n        content: '?';\n      }\n    }\n\n    .tt--info {\n      text-transform: lowercase;\n      &::before { content: 'i' }\n    }\n\n    .msg {\n      display: none;\n      position: absolute;\n      line-height: normal;\n      z-index: 1000;\n      left: 110%;\n      top: -10%;\n      \n      min-width: 250px;\n      max-width: 300px;\n      \n      padding: 0.25em 0.5em;\n      font-weight: 300;\n      font-style: italic;\n      font-size: calc(14px + 2 * ((100vw - 480px) / 960));\n      text-align: left;\n      text-transform: initial;\n\n      background: ").concat(GRAY_000, ";\n      color: ").concat(DEFAULT_TEXT, ";\n      font-family: ").concat(SERIF, ";\n    }\n\n    .icon:hover + .msg {\n      display: block;\n    }\n    \n    ").concat(MEDIA_SMALL_MAX, " {\n      .msg {\n        transform: translate(-51%, -95%);\n      }\n    }\n  "));
  var cssObj_labelReq = {
    icon: 'icon'
  };

  if (icon && icon === 'i') {
    cssObj_labelReq['tt--info'] = 'tt--info';
  } // Filter out object key/value with empty strings eq. ``


  Object.keys(cssObj_labelReq).forEach(function (k) {
    return cssObj_labelReq[k] == '' && delete cssObj_labelReq[k];
  }); // Output obj values as string of classNames

  var cssArrToString = Object.keys(cssObj_labelReq).map(function (obj) {
    return cssObj_labelReq[obj];
  }).toString().replace(/,/g, ' ');
  return jsx("div", {
    css: $wrapper
  }, jsx("div", {
    className: cssArrToString
  }), jsx("div", {
    className: "msg"
  }, msg));
};
export default ToolTip;